<p-toast position="top-right"></p-toast>
<app-confirm-dialog
  [visible]="confirmationDialogVisible"
  variant="secondary"
  heading="Confirmation"
  [message]="confirmationDialogMessage"
  cancelText="No"
  (confirmed)="confirmConfirmationDialog()"
  (cancelled)="cancelUpdateConfirmation()">
</app-confirm-dialog>
<app-confirm-dialog
  [visible]="deleteConfirmationVisible"
  variant="secondary"
  heading="Confirmation"
  message="Are you sure you want to Delete?"
  cancelText="No"
  (confirmed)="confirmDeleteOrder()"
  (cancelled)="cancelDeleteConfirmation()">
</app-confirm-dialog>
<div class="Purchase-Order-Responsive p-g">
   <div class="p-g-12 p-table-tecfolk-fix">
      <div class="card card-w-title ">
         <div class="p-g">
            <div class="p-g-6">
               <h1 style="margin-top: 0px;">{{setLabel("purchaseOrderLabel")}}</h1>
            </div>
            <div class="p-g-6">
            </div>
         </div>
         <div>
            <p-table [value]="selectedSupplier" [paginator]="false" [rows]="10" [responsive]="true">

               <ng-template pTemplate="caption" style="text-align: left">
                  <div class="reportMainFilter">
                     <div class="reportMainFields">
                        <div class="filterFields" *ngIf="mode == 'add'">
                           <span class="fieldTitle">{{setLabel("searchSupplierByNameLabel")}}</span>
                           <input #searchSupplier autocomplete="off" pinputtext=""
                              [placeholder]='setLabel("searchHerePlaceholderLabel")' type="text" name="name"
                              [(ngModel)]="supplierSearch.name" (click)="os.toggle($event)"
                              (keyup)="searchPanelSuppliers($event, supplierSearch.name, 'name')"
                              class="p-inputtext p-corner-all p-state-default p-widget">
                        </div>
                        <app-action-button
                           variant="secondary"
                           size="sm"
                           text="Go Back"
                           icon="pi pi-arrow-left"
                           title="Go Back"
                           ariaLabel="Go Back"
                           routerLink="/purchase-orders"
                           [disabled]="loading">
                        </app-action-button>
                     </div>
                     <div class="reportMainBtn">
                        <app-action-button
                           *ngIf="mode == 'edit'"
                           variant="secondary"
                           size="sm"
                           text="{{ setLabel('updateLabel') || 'Update' }}"
                           icon="fa fa-floppy-o"
                           title="{{ setLabel('updateLabel') || 'Update' }}"
                           ariaLabel="{{ setLabel('updateLabel') || 'Update' }}"
                           [disabled]="orderProduct.length == 0 || isFulFil"
                           (action)="updateOrder()">
                        </app-action-button>
                        <div>
                            <app-action-button
                              *ngIf="mode == 'edit'"
                              variant="secondary"
                              size="sm"
                              text="{{ setLabel('printBtnLabel') || 'Print' }}"
                              icon="fa fa-print"
                              title="{{ setLabel('invoiceLabel') || 'Print' }}"
                              ariaLabel="{{ setLabel('printBtnLabel') || 'Print' }}"
                              (action)="printPurchaseOrder()">
                           </app-action-button>
                           <!-- <span pTooltip="Go Back" routerLink="/purchase-orders" style="margin-right: 10rem; font-size: 15px;"><i class="pi pi-arrow-left"></i></span>
                  <button routerLink="/purchase-orders" style="background-color: #4b94d8; margin-right: 8px;"
                     class="p-button p-widget p-state-default p-corner-all p-button-text-only"><i
                        class="fa fa-arrow-left" style="margin-right: 8px;"></i>Go
                     Back
                  </button> -->
                        </div>
                     </div>
                  </div>
                  <p-overlayPanel #os id="os" styleClass="purchase-order-overlay" [dismissable]="true"
                     (onShow)="fitOverlay(os)">
                     <div class="p-table-tecfolk-fix purchase-order-overlay-content">
                        <p-table [value]="suppliersInPanel" selectionMode="single" [paginator]="true" [rows]="9"
                           [responsive]="true" (onRowSelect)="onSupplierRowSelect($event, os)"
                           [(selection)]="selectProduct" [first]="firstOfSupplierOverlay"
                           (onPage)="onSupplierPageChange($event)">

                           <ng-template pTemplate="header">
                              <tr>
                                 <th>{{setLabel("supplierNameLabel")}}</th>
                                 <th>{{setLabel("imageLabel")}}</th>
                                 <th>{{setLabel("mobileNoLabel")}}</th>
                              </tr>
                           </ng-template>

                           <ng-template pTemplate="body" let-perm let-rowIndex="rowIndex">
                              <tr [pSelectableRow]="perm" id="opRowIds-{{rowIndex}}" class="opSelectedRow">
                                 <td style="color: #000000;">
                                    {{perm.name}}</td>
                                 <td style="color: #000000;">
                                    <a>
                                       <img [alt]="" src="{{perm.profile}}" width="30" style="vertical-align: middle" />
                                    </a>
                                 </td>
                                 <td style="color: #000000;">
                                    {{perm.phone}}</td>
                              </tr>
                           </ng-template>

                           <ng-template pTemplate="emptymessage" let-columns>
                              <tr style="color: black;">
                                 <td>
                                    {{setLabel("noSupplierFoundLabel")}}
                                 </td>
                              </tr>
                           </ng-template>

                        </p-table>
                     </div>
                  </p-overlayPanel>
               </ng-template>

               <ng-template pTemplate="header">
                  <tr>
                     <th style="max-width: 90px;">{{setLabel("supplierNameLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("photoLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("mobileNoLabel")}}</th>
                  </tr>
               </ng-template>

               <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                  <tr class="search-supplier-tr" style="background: whitesmoke;">

                     <td>
                        <div class="mobile-Lable">{{setLabel("supplierNameLabel")}}</div>
                        {{rowData.name}}
                     </td>


                     <td>
                        <div class="mobile-Lable-Image">{{setLabel("photoLabel")}}</div>
                        <a>
                           <img [alt]="" src="{{rowData.profile}}" width="30" style="vertical-align: middle" />
                        </a>
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("mobileNoLabel")}}</div>
                        {{rowData.phone}}
                     </td>
                  </tr>
               </ng-template>

               <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                     <td rowspan="3">
                        {{setLabel("noSupplierAddedLabel")}}
                     </td>
                  </tr>
               </ng-template>

            </p-table>
            <!-- ////////////////////////////////////////////////////////////////////////////////////////////////////////////// -->
            <p-table [value]="orderProduct" [paginator]="false" [rows]="10" [responsive]="true">

               <ng-template pTemplate="caption" style="text-align: left">

                  <input id="searchProduct" #searchProduct *ngIf="!isFulFil" autocomplete="off" pinputtext=""
                     [placeholder]='setLabel("searchProductByNamePlaceholderLabel")' type="text" name="name"
                     [(ngModel)]="product.name" (click)="op.toggle($event)"
                     (keyup)="searchPanelProducts($event, product.name, 'name')"
                     class="ng-pristine ng-valid ng-touched">

                  <p-overlayPanel #op id="op" styleClass="purchase-order-overlay" [dismissable]="true"
                     (onShow)="fitOverlay(op)">
                     <div class="p-table-tecfolk-fix purchase-order-overlay-content">
                        <p-table [value]="productsInPanel" selectionMode="single" [paginator]="true" [rows]="5"
                           [responsive]="true" (onRowSelect)="onProductRowSelect($event, op)"
                           [(selection)]="selectProduct" id="opPtable" #opPtable [first]="first"
                           (onPage)="onPageChange($event)">

                           <ng-template pTemplate="header">
                              <tr>
                                 <th>{{setLabel("codeLabel")}}</th>
                                 <th>{{setLabel("imageLabel")}}</th>
                                 <th>{{setLabel("itemLabel")}}</th>
                                 <th>{{setLabel("purchasePriceLabel")}}</th>
                                 <th>{{setLabel("inStockLabel")}}</th>
                              </tr>
                           </ng-template>

                           <ng-template pTemplate="body" let-perm let-rowIndex="rowIndex">
                              <tr [pSelectableRow]="perm" id="opRowIds-{{rowIndex}}" class="opSelectedRow">
                                 <td style="color: #000000;">{{perm.code}}</td>
                                 <td style="color: #000000;">
                                    <a>
                                       <img [alt]="" src="{{perm.imagePath}}" width="30"
                                          style="vertical-align: middle" />
                                    </a>
                                 </td>
                                 <td style="color: #000000;">{{perm.name}}</td>
                                 <td style="color: #000000;">{{perm.cost | number:'1.0-0'}}</td>
                                 <td style="color: #000000;">{{perm.totalQuantity}}</td>
                              </tr>
                           </ng-template>

                           <ng-template pTemplate="emptymessage" let-columns>
                              <tr style="color: black;">
                                 <td>
                                    {{setLabel("noRecordsFoundLabel")}}
                                 </td>
                              </tr>
                           </ng-template>

                        </p-table>
                     </div>
                  </p-overlayPanel>
               </ng-template>

               <ng-template pTemplate="header">
                  <tr>
                     <th style="max-width: 130px;">{{setLabel("actionLabel")}}</th>
                     <th style="max-width: 90px;">{{setLabel("codeLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("itemLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("quantityLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("purchasePriceLabel")}}</th>
                     <th style="max-width: 130px;">{{setLabel("sub-TotalLabel")}}</th>
                     <th *ngIf="mode == 'edit'" style="max-width: 130px;">{{setLabel("wholesalePrice/UnitLabel")}}</th>
                     <th *ngIf="mode == 'edit'" style="max-width: 130px;">{{setLabel("retailPrice/UnitLabel")}}</th>
                  </tr>
               </ng-template>

               <ng-template pTemplate="body" let-rowData let-rowIndex="rowIndex">
                  <tr class="search-Product-tr">
                     <td>
                        <div class="mobile-Lable">{{setLabel("actionLabel")}}</div>
                        <button pButton (click)="removeSelectedProduct(rowData)" type="button"
                           [pTooltip]='setLabel("removeTooltipLabel")' [disabled]="isFulFil" icon="fa fa-times"
                           style="margin-right: 5px; color: #ffffff; background-color: #F44336;">
                        </button>
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("codeLabel")}}</div>

                        {{rowData.code}}
                     </td>
                     <td>

                        <div class="mobile-Lable">{{setLabel("itemLabel")}}</div>
                        {{rowData.name}}
                     </td>
                     <td>
                        <div class="mobile-Lable">{{setLabel("quantityLabel")}}</div>

                        <input style="width: 75%;" id="rowQuantity-{{rowIndex}}" pinputtext="" autocomplete="off"
                           type="number" name="quantity" class="p-corner-all p-state-default p-widget"
                           [(ngModel)]="rowData.quantity" min="1" oninput="this.value=Math.max(1,this.value);"
                           (ngModelChange)="quantityChangeEvent(rowData, 'quantity')" [disabled]="isFulFil"
                           (keyup)="quantityChangeEvent(rowData,'quantity')">
                        <span *ngIf="rowData.unit === 'g'"> <b> {{setLabel("kgLabel")}}</b></span>
                        <span *ngIf="rowData.unit === 'ml'"> <b> {{setLabel("literLabel")}}</b></span>
                     </td>

                     <td>
                        <div class="mobile-Lable">{{setLabel("purchasePriceLabel")}}</div>

                        <input style="width: 75%;" id="rowPurchasePrice-{{rowIndex}}" pinputtext="" autocomplete="off"
                           type="number" name="purchasePrice" [disabled]="isFulFil"
                           class="p-corner-all p-state-default p-widget" [(ngModel)]="rowData.cost" min="1"
                           oninput="this.value=Math.max(0,this.value);"
                           (ngModelChange)="quantityChangeEvent(rowData, 'purchasePrice')">
                     </td>

                     <!-- <td>{{rowData.cost}}</td> -->

                     <td>

                        <div class="mobile-Lable">{{setLabel("sub-TotalLabel")}}</div>

                        <input style="width: 75%;" pinputtext="" autocomplete="off" type="number" [disabled]="isFulFil"
                           name="subtotal" class="p-corner-all p-state-default p-widget" [(ngModel)]="rowData.subTotal"
                           min="1" readonly>
                     </td>

                     <td *ngIf="mode == 'edit'">
                        <div class="mobile-Lable">{{setLabel("wholesalePrice/UnitLabel")}}</div>

                        <input style="width: 75%;" id="rowWholeSalePrice-{{rowIndex}}" [disabled]="isFulFil"
                           pinputtext="" autocomplete="off" type="number" name="wholeSalePrice"
                           class="p-corner-all p-state-default p-widget" [(ngModel)]="rowData.wholeSalePrice" min="1">
                     </td>

                     <td *ngIf="mode == 'edit'">
                        <div class="mobile-Lable">{{setLabel("retailPrice/UnitLabel")}}</div>

                        <input style="width: 75%;" id="rowSalePrice-{{rowIndex}}" [disabled]="isFulFil" pinputtext=""
                           autocomplete="off" type="number" name="salePrice"
                           class="p-corner-all p-state-default p-widget" [(ngModel)]="rowData.normalPrice" min="1">
                     </td>

                     <!-- <td>{{rowData.subTotal}}</td> -->

                  </tr>
               </ng-template>

               <ng-template pTemplate="emptymessage" let-columns>
                  <tr>
                     <td>
                        {{setLabel("noProductAddedLabel")}}
                     </td>
                  </tr>
               </ng-template>
               <!-- //////////////////////////////////////////////////////////////////////////////////////// -->
            </p-table>

            <p-table [value]="[newPurchaseOrder]" [paginator]="false" [rows]="10" [responsive]="true">
               <ng-template pTemplate="footer">
                  <tr class="footer">
                     <td class="hidden" colspan="1" style="background-color: #edf1ff;"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td colspan="2" style="width: 35%; font-size: 16px; font-weight: 500; background-color:#edf1ff">
                        {{setLabel("grandTotalLabel")}}
                     </td>
                     <td colspan="2" style="font-size: 16px; font-weight: 700; background-color:#edf1ff">
                        {{newPurchaseOrder.subTotal | number:'1.0-0'}}</td>
                  </tr>
                  <tr class="footer" *ngIf="isFulFil">
                     <td class="hidden" colspan="1" style="background-color: #edf1ff;"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td colspan="2" style="width: 35%; font-size: 16px; font-weight: 500; background-color:#edf1ff">
                        {{setLabel("amountPaidLabel")}}
                     </td>
                     <td colspan="2" style="font-size: 16px; font-weight: 700; background-color:#edf1ff">
                        {{newPurchaseOrder.paid | number:'1.0-0'}}</td>
                  </tr>
                  <tr class="footer" *ngIf="mode === 'edit' && !isFulFil">
                     <td class="hidden" colspan="1" style="background-color: #edf1ff;"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td colspan="2" style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                        {{ newPurchaseOrder?.remainingSubtotal > 0 ? setLabel('remainingAmountLabel') : setLabel('amountPaidLabel') }}
                     </td>
                     <td colspan="2" style="font-size: 16px; font-weight: 700; background-color:#edf1ff">
                        <input pinputtext="" autocomplete="off" type="number" name="salePrice" [disabled]="isFulFil"
                           class="p-corner-all p-state-default p-widget" [(ngModel)]="displayPaymentAmount" min="0"
                           style="width: 14.5em;" oninput="this.value = Math.max(0, parseInt(this.value) || 0)"/>
                     </td>
                  </tr>
                  <tr *ngIf="displayPaymentAmount > newPurchaseOrder.subTotal || (displayPaymentAmount > newPurchaseOrder.remainingSubtotal &&  newPurchaseOrder.remainingSubtotal > 0)" class="footer">
                     <td class="hidden" colspan="1" style="background-color: #edf1ff;"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td colspan="2" style="width: 35%; font-size: 16px; font-weight: 500; background-color:#edf1ff">
                        {{setLabel("balanceReturnedLabel")}}
                     </td>
                     <td *ngIf="isFulFil" colspan="2" style="font-size: 16px; font-weight: 700; background-color:#edf1ff">
                        {{newPurchaseOrder.returned | number:'1.0-0'}}</td>
                     <td *ngIf="mode == 'edit' && !isFulFil" colspan="2" style="font-size: 16px; font-weight: 700; background-color:#edf1ff">
                        {{newPurchaseOrder?.remainingSubtotal > 0 ? displayPaymentAmount - newPurchaseOrder.remainingSubtotal : displayPaymentAmount - newPurchaseOrder.subTotal | number:'1.0-0'}}</td>
                  </tr>
                  <tr class="footer" *ngIf="mode === 'edit' && !isFulFil">
                     <td class="hidden" colspan="1" style="background-color: #edf1ff;"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td class="hidden" style="background-color:#edf1ff"></td>
                     <td colspan="2" style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
                        {{setLabel("modeOfPaymentLabel")}}
                     </td>
                     <td colspan="2" style="font-size: 16px; font-weight: 700; background-color:#edf1ff">
                        <p-dropdown [options]="paymentOptions"
                           (onChange)="onPaymentModeChange($event.value)"></p-dropdown>
                     </td>
                  </tr>
                  <tr class="footer" *ngIf="mode === 'edit' && isFulFil">
    <td class="hidden" colspan="5" style="background-color:#edf1ff"></td>

    <td colspan="2"
        style="font-size: 16px; font-weight: 500; background-color:#edf1ff">
        {{setLabel("modeOfPaymentLabel")}}
    </td>

    <td colspan="2"
        style="font-size: 16px; font-weight: 700; background-color:#edf1ff">
        {{newPurchaseOrder.paymentMode || 'N/A'}}
    </td>
</tr>
                  <tr class="remarks-Tr" style="border-bottom: 1px solid;">
                     <td colspan="5" style="background-color: #edf1ff;">
                        <textarea rows="4" cols="67" name="remarks" [(ngModel)]="newPurchaseOrder.remarks"
                           [placeholder]='setLabel("remarksLabel")'></textarea>
                     </td>
                     <td colspan="2" style="background-color:#edf1ff">

                        <button (click)="suspendOrder()" id="suspendButton" *ngIf="mode == 'add'; else delete"
                           style="background-color: #ffffff; margin-right: 8px; width: 100%; color: red; border: 2px solid red;"
                           [disabled]="!(orderProduct.length >= 1)"
                           class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                           {{setLabel("suspendLabel")}}
                        </button>

                        <ng-template #delete>
                           <button type="button" (click)="deleteOrder()" id="deleteButton"
                              style="background-color: #ffffff; margin-right: 8px; width: 100%; color: red; border: 2px solid red;"
                              [disabled]="loading || isFulFil"
                              class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                              {{setLabel("deleteLabel")}}
                           </button>
                        </ng-template>

                     </td>
                     <td colspan="2" style="background-color:#edf1ff">
                        <button (click)="generateOrder()" id="generateOrderButton" *ngIf="mode == 'add'"
                           style="background-color: #5192d0; margin-right: 8px; width: 100%;"
                           [disabled]="!((orderProduct.length >= 1) && !disableCheckoutOnSuccess)"
                           class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                           {{setLabel("generateLabel")}}
                        </button>

                        <button (click)="fulfilOrder()" id="fulfilOrderButton" *ngIf="mode == 'edit'"
                           style="background-color: #5192d0; margin-right: 8px; width: 100%;"
                           [disabled]="!((orderProduct.length >= 1) && !disableCheckoutOnSuccess && !isFulFil)"
                           class=" p-button-info p-button p-widget p-state-default p-corner-all p-button-text-only">
                           {{fulFilButtonName}}
                        </button>
                     </td>
                  </tr>
               </ng-template>

            </p-table>
         </div>
      </div>
   </div>
</div>

<div id="purchaseOrder" style="display: none;">
   <div class="invoice-box" style="padding: 0px !important;  width: 57mm; max-width: 57mm; margin: 0 !important;">
      <div style="width: 57mm;max-width: 57mm;">
         <img
            [src]=" (company.bannerImage ? config.Server + 'assets/layout/images/companies/' + company.bannerImage : 'assets/layout/images/logoCompany.png')"
            alt="Company Logo" style="
    display: block;
    margin-left: auto;
    margin-right: auto;
    width: 58%;
    margin-top: 3px;
    margin-bottom: 2px;
" />
         <div style="
    text-align: center;
    font-size: 11px;
    line-height: 14px;
    color: black;
">
            {{ branch.name }}
         </div>
         <div style="
    text-align: center;
    font-size: 11px;
    line-height: 14px;
    color: black;
">
            {{ branch.address }}
         </div>
         <div style="
    text-align: center;
    font-size: 11px;
    line-height: 15px;
    color: black;
">
            {{ branch.phone }}
         </div>

         <table
            style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">

            <tbody>
               <tr>
                  <td style="font-size: 10px;text-align: center;padding: 0px; font-weight: bold;">
                     {{setLabel("supplierLabel")}}</td>
                  <td style="font-size: 10px;text-align: center; padding: 0px; font-weight: bold;"></td>
                  <td style="font-size: 10px;text-align: center; padding: 0px;font-weight: bold;">
                     {{setLabel("mobile#Label")}}</td>
               </tr>
               <tr>
                  <td style="font-size: 10px;text-align: center; padding: 0px;">{{newPurchaseOrder.supplier?.name}}</td>
                  <td style="font-size: 10px;text-align: center; padding: 0px;"></td>
                  <td style="font-size: 10px;text-align: center; padding: 0px;">{{newPurchaseOrder.supplier?.phone}}</td>
               </tr>

            </tbody>
         </table>

         <table
            style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">
            <tbody>
               <tr>
                  <td style="font-size: 10px;text-align: center;padding: 0px; font-weight: bold;">
                     {{setLabel("purchaseOrder#Label")}}</td>
                  <td style="font-size: 10px;text-align: center; padding: 0px; font-weight: bold;"></td>
                  <td style="font-size: 10px;text-align: center; padding: 0px;font-weight: bold;">
                     {{setLabel("createdLabel")}}</td>
               </tr>
               <tr>
                  <td style="font-size: 10px;text-align: center; padding: 0px;">{{newPurchaseOrder.purchaseOrderNumber}}
                  </td>
                  <td style="font-size: 10px;text-align: center; padding: 0px;"></td>
                  <td style="font-size: 10px;text-align: center; padding: 0px;">{{newPurchaseOrder.purchaseOrderDate |
                     date: 'd/M/yy, h:mm a'}}</td>
               </tr>

            </tbody>
         </table>

         <table
            style="border-collapse: collapse; font-size: 12px; font-size: 9px;margin-top: 3px; line-height: normal;">

            <thead
               style=" text-align: center;font-weight: bold; font-size: 12px; font-size: 9px; background-color: black;color: white;">
               <tr style="background-color: black;color: white; border: 1px solid black;">
                  <th style="width: 40px;  word-break: break-word; font-size: 10px;">{{setLabel("itemLabel")}}</th>
                  <th style="width: 40px;  word-break: break-word; font-size: 10px; ">{{setLabel("qTYLabel")}}</th>
                  <th style="width: 40px;  word-break: break-word; font-size: 10px; ">{{setLabel("purchasePriceLabel")}}
                  </th>
                  <th style="width: 40px;  word-break: break-word; font-size: 10px; ">{{setLabel("sub-TotalLabel")}}
                  </th>
               </tr>
            </thead>
            <!-- ////////////////////////////////////////////////////// -->
            <tbody>
               <span>
                  <tr *ngFor="let item of newPurchaseOrder.products">
                     <td style="font-size: 9px;border:1px solid black;text-align: center;">{{item.name}}</td>
                     <td style="font-size: 9px;border:1px solid black;text-align: center;">{{item.quantity}}</td>
                     <td style="font-size: 9px;border:1px solid black;text-align: center;">{{item.cost | number:'1.0-0'}}</td>
                     <td style="font-size: 9px;border:1px solid black;text-align: center;">{{item.subTotal | number:'1.0-0'}}</td>
                  </tr>
               </span>
               <tr>
                  <td style="font-size: 10px; text-align: center;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
                     colspan="3">{{setLabel("grand-TotalLabel")}} </td>
                  <td style="font-size: 10px;text-align: center; border-right: 1px solid; border-bottom: 1px solid;">{{newPurchaseOrder.subTotal | number:'1.0-0'}}
                  </td>
               </tr>
               <tr *ngIf="newPurchaseOrder.paid > 0">
                  <td style="font-size: 10px; text-align: center;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
                     colspan="3">{{setLabel("amountPaidLabel")}} </td>
                  <td style="font-size: 10px;text-align: center; border-right: 1px solid;border-bottom: 1px solid;">{{newPurchaseOrder.paid | number:'1.0-0'}}</td>
               </tr>
               <tr *ngIf="newPurchaseOrder.returned > 0">
                  <td style="font-size: 10px; text-align: center;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
                     colspan="3">{{setLabel("balanceReturnedLabel")}} </td>
                  <td style="font-size: 10px;text-align: center; border-right: 1px solid;border-bottom: 1px solid;">{{newPurchaseOrder.returned | number:'1.0-0'}}
                  </td>
               </tr>
               <tr *ngIf="newPurchaseOrder.remainingSubtotal > 0">
                  <td style="font-size: 10px; text-align: center;  font-weight: bold;border-bottom: 1px solid;border-left: 1px solid; "
                     colspan="3">{{setLabel("remainingSubtotalLabel")}} </td>
                  <td style="font-size: 10px;text-align: center; border-right: 1px solid;border-bottom: 1px solid;">{{newPurchaseOrder.remainingSubtotal |
                     number:'1.0-0'}}</td>
               </tr>
               
            </tbody>
         </table>

         <table *ngIf="newPurchaseOrder.remarks != undefined"
            style="border-collapse: collapse; font-size: 12px; font-size: 9px;border: 1px solid black;line-height: 12px; margin-top: 8px;">
            <tr>
               <td style="font-size: 10px;text-align: center;padding: 0px; font-weight: bold;">
                  {{setLabel("remarksLabel")}}</td>
            </tr>
            <tr>
               <td style="font-size: 10px;text-align: center; padding: 0px;">{{newPurchaseOrder.remarks}}</td>
            </tr>
         </table>

         <div
            style=" text-align: center;padding-top: 6px; font-size: 10px; font-weight: bold;color: black;white-space: nowrap;">
            {{setLabel("softwareLabel")}}
         </div>

      </div>
   </div>

</div>